import { render } from "./Activation.vue?vue&type=template&id=2fab0a08"
import script from "./Activation.vue?vue&type=script&lang=js"
export * from "./Activation.vue?vue&type=script&lang=js"

import "./Activation.vue?vue&type=style&index=0&id=2fab0a08&lang=scss"

import exportComponent from "C:\\wamp2022\\www\\emotivapp\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__